var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "subscriptions"
    }
  }, [(!_vm.isActive) ? _c('router-link', {
    attrs: {
      "to": "/payment"
    }
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button mb-2",
    attrs: {
      "size": "sm"
    }
  }, [_vm._v("Subscribe")])], 1) : _vm._e(), _vm._v(" "), _c('AdminTableContainer', {
    attrs: {
      "users": _vm.localUsers,
      "headers": _vm.headers,
      "options": _vm.options
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-812200d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/ManageSubscription/ManageSubscription.vue
// module id = aU1R
// module chunks = 2